import BigNumber from 'bignumber.js';
/*
 * DECIMAL_PLACES: maximum number of decimal places when using division
 * ROUNDING_MODE: use bankers' rounding
 */
export const CurrencyBN = BigNumber.clone({
    DECIMAL_PLACES: 2,
    ROUNDING_MODE: BigNumber.ROUND_HALF_EVEN,
});
//# sourceMappingURL=currencyBN.js.map